import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { Register, TreeComponent } from '@xanadu/core';
import { Node, Branch, Client, Club } from '@xanadu/model';
import { NodeModel } from '@xanadu/model';
import { Observable } from 'rxjs';
import { ClientMenuBuilder } from '@xanadu/menu';

@Component({
    selector: 'app-client-tree',
    templateUrl: './client-tree.component.html',
    styleUrls: ['./client-tree.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
@Register('client-tree')
export class ClientTreeComponent extends TreeComponent<Client | Club> {
    menuBuilder = inject(ClientMenuBuilder);

    protected override get nodeType(): string | undefined {
        return 'client';
    }

    onClub() {
        const club = new Club(undefined);
        club.name = 'new club';
        this.addChild(club);
    }

    onClient() {
        const client = new Client(undefined);
        client.name = 'new client';

        this.addChild(client);
    }

    onPaste() {
        this.paste();
    }

    protected dropOk(dragModel: NodeModel, dropModel: NodeModel): boolean {
        const dragNode = dragModel.node;
        const dropNode = dropModel.node as Branch;

        return dragNode.fit(dropNode);
    }

    protected replace(node: Node, branch: Branch): Observable<Client | Club> {
        return this.dataService.replace<Client | Club>(node as any, branch);
    }
}
